import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { InspectionSchema } from '../entities/inspection.js';
export const CompleteInspectionBodySchema = z.object({
    dateReviewed: z.iso.datetime().optional(),
    reviewedBy: z.string().optional(),
});
export const CompleteInspectionApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    body: CompleteInspectionBodySchema,
    response: InspectionSchema,
};
export const CompleteInspectionRequestSchema = CompleteInspectionApiSchema.params
    .merge(CompleteInspectionApiSchema.body)
    .merge(CompleteInspectionApiSchema.headers);
